// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#bb_view_filter_toggle {\n  padding: 5px;\n  background: #eaf0f6;\n  border-radius: 8px;\n  height: 45px;\n  width: 215px;\n}\n#bb_view_filter_toggle .btn {\n  border-radius: 8px;\n  background: #eaf0f6;\n  border: transparent;\n  padding: 6px 20px;\n  font-weight: 500;\n  font-size: 16px;\n}\n#bb_view_filter_toggle .active {\n  background: #ffffff;\n  border: transparent;\n}", ""]);
// Exports
module.exports = exports;
